/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Container, Button, Spinner, Modal, Alert } from "react-bootstrap";
import {
  faBriefcase,
  faChartSimple,
  faInfoCircle,
  faLocation,
  faSackDollar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Header from "../../Common/Header";
import Footer from "../../Common/Footer/Footer";
import useViewJobInvite from "./useViewJobInvite";
import { dateDiff } from "../../../_helpers/dateFormatter";

function ViewJobInvite(props) {
  const {
    jobDetails,
    jobDetailsLoading,
    jobApplyLoading,
    formSubmitError,
    loading,
    interviewKit,
    userDetails,

    onJobApplyClick,
    onJobShareClick,
    onViewAllJobsClick,
    handleClose,
    onSubmitForm,
    onProfileUpdate,
    onFormDataChange,
    onAssessmentKitsClick,
    onCalendarDashoardClick,
    onPublicProfileClick,
    onRejectInvitation,
    handleRejectInvitationModal,
    onPracticeClick,
    onStartClick,
  } = useViewJobInvite(props);

  return (
    <>
      <Header />
      <Container>
        <div className=" job-board-expanded footer-gap">
          <div className="top-cards-wrapper">
            <div className="mb-2 job-list-section">
              <div className="d-flex align-items-center my-3 pb-3">
                <h4 className="text-uppercase mr-4 text-nowrap">
                  WELCOME TO A BETTER JOB SEARCH
                </h4>
                <span className="border-bottom" style={{ width: "85%" }}></span>
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="p-4 border position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Connect your google calendar
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            Let hiring managers know your availability and
                            schedule interviews with you with a click of a
                            button. Get your very own calendar availability
                            link.
                          </p>
                          <button
                            className="btn btn-light mt-5"
                            onClick={onCalendarDashoardClick}
                          >
                            Connect Calendar
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4">
                  <div className="p-4 border position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Assessment kits
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            Never answer the same questions on multiple
                            interviews. Take the assessment kit and your video
                            recorded responses can be shared with any hiring
                            manager you choose. Be instantly hireable
                          </p>
                          <button
                            className="btn btn-light mt-4"
                            onClick={onAssessmentKitsClick}
                          >
                            Learn More
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 mb-4 ">
                  <div className="p-4 border position-relative h-100 rounded-lg">
                    <div className="card-wrapper">
                      <div className="d-flex mb-3 align-items-start">
                        <div className="job-info">
                          <h4 className="font-weight-medium mb-1 text-capitalize pb-2">
                            Your hiring profile
                          </h4>
                          <p className="text-grey-4 fs-smallest">
                            One link with your calendar availability, your video
                            recorded responses and your resume which you can
                            explicitly share with hiring managers.
                          </p>
                          <button
                            className="btn btn-light mt-5"
                            onClick={onPublicProfileClick}
                          >
                            View
                          </button>
                        </div>
                        <img
                          src={"/assets/images/building-placeholder.png"}
                          alt="company logo"
                          className="border-radius-10 ml-3 card-img"
                          style={{ width: "48px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-8 mb-3">
                <div className="container border rounded-lg">
                  {jobDetailsLoading ? (
                    <div className="d-flex justify-content-center align-items-center w-100">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : (
                    <>
                      <div className="job-expanded-info px-4 h-100">
                        {jobDetails?.status === "inactive" ? (
                          <div className="text-center ">
                            <Alert
                              variant={"danger"}
                              className="mt-3 text-center d-inline-flex align-items-center font-weight-medium"
                            >
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-3 h2 mb-0"
                              />
                              This Job has been closed now !
                            </Alert>
                          </div>
                        ) : null}

                        {jobDetails?.invite_status === "rejected" ? (
                          <div className="text-center ">
                            <Alert
                              variant={"danger"}
                              className="mt-3 text-center d-inline-flex align-items-center font-weight-medium"
                            >
                              <FontAwesomeIcon
                                icon={faInfoCircle}
                                className="mr-3 h2 mb-0"
                              />
                              You have rejected this job invitation!
                            </Alert>
                          </div>
                        ) : null}

                        {jobDetails?.title && (
                          <div className="bottom position-relative">
                            <div className="job-meta d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center flex-1">
                                <img
                                  src={
                                    jobDetails?.posted_by_details &&
                                    jobDetails?.posted_by_details
                                      ?.company_details &&
                                    jobDetails?.posted_by_details
                                      .company_details?.logo === null
                                      ? "/assets/images/company-logo-placeholder.png"
                                      : jobDetails?.posted_by_details &&
                                        jobDetails?.posted_by_details
                                          ?.company_details &&
                                        jobDetails?.posted_by_details
                                          .company_details?.logo
                                  }
                                  alt="company logo"
                                  className="border-radius-10 mr-3 align-self-end"
                                  style={{
                                    width: "70px",
                                    height: "70px",
                                    objectFit: "cover",
                                  }}
                                />
                                <div className="mt-3 text-capitalize">
                                  <div className="d-inline-block">
                                    <h3 className="mb-1 text-primary">
                                      {jobDetails?.title}
                                    </h3>
                                    <p className="text-grey-4 mb-1">
                                      <span>
                                        {jobDetails?.posted_by_details &&
                                          jobDetails.posted_by_details
                                            ?.company_details &&
                                          jobDetails.posted_by_details
                                            .company_details?.name}
                                      </span>
                                      ,{" "}
                                      <span className="text-capitalize">
                                        {jobDetails?.state_name},{" "}
                                      </span>
                                      <span className="text-uppercase">
                                        {jobDetails?.country_name}
                                      </span>
                                    </p>
                                    <p className="mb-0 text-grey-4">
                                      <span>
                                        {dateDiff(
                                          jobDetails?.created,
                                          new Date()
                                        )}{" "}
                                        ago
                                      </span>
                                      {", "}
                                      <span>
                                        {jobDetails?.total_candidates}{" "}
                                        Applicants
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <ul className="fs-smallest d-flex flex-wrap align-items-center py-5">
                              <li className="p-2 flex-grow-1 d-flex align-items-center">
                                <div className="icon bg-light-blue rounded-lg mr-3">
                                  <FontAwesomeIcon
                                    icon={faSackDollar}
                                    className="p-2 text-primary fa-2x ml-1 mt-1"
                                  />
                                </div>
                                <div>
                                  <p className="mb-0 text-primary font-weight-medium text-uppercase">
                                    {jobDetails?.payment_currency}{" "}
                                    {jobDetails?.payment_from} -{" "}
                                    {jobDetails?.payment_to}/
                                    <span className="text-capitalize">
                                      {jobDetails?.payment_type}
                                    </span>
                                  </p>
                                  <p className="text-grey-4 mb-0">Salary</p>
                                </div>
                              </li>
                              <li className="p-2 flex-grow-1 d-flex align-items-center">
                                <div className="icon bg-light-blue rounded-lg mr-3">
                                  <FontAwesomeIcon
                                    icon={faBriefcase}
                                    className="p-2 text-primary fa-2x ml-1 mt-1"
                                  />
                                </div>
                                <div>
                                  <p className="mb-0 text-primary font-weight-medium">
                                    <p className="mb-0 text-primary">
                                      Minimum{" "}
                                      {jobDetails?.experience.replace(
                                        /_/g,
                                        " "
                                      )}
                                    </p>
                                  </p>
                                  <p className="text-grey-4 mb-0">Experience</p>
                                </div>
                              </li>

                              <li className="d-flex align-items-center p-2 flex-grow-1">
                                <div className="icon bg-light-blue rounded-lg mr-3">
                                  <FontAwesomeIcon
                                    icon={faLocation}
                                    className="p-2 text-primary fa-2x ml-1 mt-1"
                                  />
                                </div>
                                <div>
                                  <p className="mb-0 text-primary  font-weight-medium">
                                    {jobDetails?.job_function}
                                  </p>
                                  <p className="text-grey-4 mb-0">
                                    Job Function
                                  </p>
                                </div>
                              </li>
                              <li className="d-flex align-items-center p-2 flex-grow-1">
                                <div className="icon bg-light-blue rounded-lg mr-3">
                                  <FontAwesomeIcon
                                    icon={faChartSimple}
                                    className="p-2 text-primary fa-2x ml-1 mt-1"
                                  />
                                </div>
                                <div>
                                  <p className="mb-0 text-primary text-capitalize font-weight-medium">
                                    {jobDetails?.employment_type.replace(
                                      /_/g,
                                      " "
                                    )}
                                  </p>
                                  <p className="text-grey-4 mb-0">Job Type</p>
                                </div>
                              </li>
                            </ul>

                            <div className="mb-2">
                              <p className="font-weight-medium mb-1">
                                Comapany Overview:{" "}
                              </p>
                              <div
                                className="text-grey-4"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    jobDetails?.posted_by_details &&
                                    jobDetails.posted_by_details
                                      ?.company_details &&
                                    jobDetails.posted_by_details.company_details
                                      ?.overview,
                                }}
                              ></div>
                            </div>

                            <div className="mb-2 mt-3">
                              <p className="font-weight-medium mb-1">
                                Job Description:{" "}
                              </p>
                              <div
                                className="text-grey-4"
                                dangerouslySetInnerHTML={{
                                  __html: jobDetails?.role_description,
                                }}
                              ></div>
                            </div>
                            <div className="mb-2 mt-3">
                              <p className="font-weight-medium mb-1">
                                Requirements
                              </p>
                              <div
                                className="text-grey-4"
                                dangerouslySetInnerHTML={{
                                  __html: jobDetails?.role_requirements,
                                }}
                              ></div>
                            </div>
                            <div className="mb-2 mt-3">
                              <p className="font-weight-medium mb-1">
                                Benefits
                              </p>
                              <div
                                className="text-grey-4"
                                dangerouslySetInnerHTML={{
                                  __html: jobDetails?.role_benefits,
                                }}
                              ></div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="col-lg-4">
                <div className="border-radius-10 border p-3 rounded-lg assigned-kit-box">
                  <div className="d-flex content-header justify-content-between">
                    <div className="company-icon d-flex">
                      <img
                        src={
                          interviewKit?.job_detail &&
                          interviewKit.job_detail?.posted_by_details &&
                          interviewKit.job_detail.posted_by_details
                            ?.company_details &&
                          interviewKit.job_detail.posted_by_details
                            .company_details?.logo
                            ? interviewKit?.job_detail &&
                              interviewKit.job_detail?.posted_by_details &&
                              interviewKit.job_detail.posted_by_details
                                ?.company_details &&
                              interviewKit.job_detail.posted_by_details
                                .company_details?.logo
                            : "/assets/images/company-logo-placeholder.png"
                        }
                        alt="company logo"
                        className="border-radius-10 mr-3 align-self-end"
                        style={{
                          width: "70px",
                          height: "70px",
                          objectFit: "cover",
                        }}
                      />
                      <div className="top-content ml-4">
                        <h3 className="font-weight-bold mb-1 text-primary">
                          {interviewKit?.title}
                        </h3>
                        <p className="text-grey-4">
                          {interviewKit?.job_detail &&
                            interviewKit.job_detail?.title}{" "}
                          @{" "}
                          {interviewKit?.job_detail &&
                            interviewKit.job_detail?.posted_by_details &&
                            interviewKit.job_detail.posted_by_details
                              ?.company_details &&
                            interviewKit.job_detail.posted_by_details
                              .company_details?.name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="body-content py-3">
                    <div className="row mx-n1">
                      <div className="col-6 px-1">
                        <p className="text-grey-4  font-weight-medium mb-2">
                          Total Topics:
                          <span className="text-dark ml-2 font-weight-medium">
                            {Array.isArray(interviewKit?.topics) &&
                              interviewKit?.topics &&
                              interviewKit.topics.length}
                          </span>
                        </p>
                      </div>
                      <div className="col-6 px-1">
                        <p className="text-grey-4 font-weight-medium mb-2">
                          Questions:
                          <span className="text-dark ml-2 font-weight-medium">
                            {interviewKit?.total_question}
                          </span>
                        </p>
                      </div>
                      <div className="col-6 px-1">
                        <p className="text-grey-4 ont-weight-medium mb-2">
                          Estimated Time:
                          <span className="text-dark ml-2 font-weight-medium">
                            {interviewKit?.total_time} Mins
                          </span>
                        </p>
                      </div>
                      <div className="col-6 px-1">
                        <p className="text-grey-4 font-weight-medium mb-2">
                          Submit By:
                          <span className="text-dark ml-2 font-weight-medium">
                            {interviewKit?.due_date}
                          </span>
                        </p>
                      </div>
                    </div>
                    <h4 className="my-3">Overview of Assessment kit:</h4>
                    <ul className="bullets text-grey-4 pl-4">
                      <li className="mb-3">
                        During this assessment kit round, you’ll have{" "}
                        {Array.isArray(interviewKit?.topics) &&
                          interviewKit?.topics &&
                          interviewKit.topics.length}{" "}
                        topics -
                        {Array.isArray(interviewKit?.topics) &&
                          interviewKit.topics.map((i) => (
                            <span className="text-dark-2 font-weight-medium">
                              {i?.name},{" "}
                            </span>
                          ))}
                      </li>
                      <li>
                        Once you qualify this round, you will be moved to{" "}
                        <span className="text-dark-2 font-weight-medium">
                          video interview
                        </span>{" "}
                        with hiring manager and it will be another interview at
                        Zydelo.
                      </li>
                    </ul>
                    <h4 className="my-3">How to get started:</h4>
                    <ul className="bullets text-grey-4 pl-4">
                      <li className="mb-3">
                        Ensure you have a stable network connection to avoid
                        interruptions during the assessment.
                      </li>
                      <li className="mb-3">
                        Select a quiet environment with no background noise and
                        a clear background for the assessment.
                      </li>
                      <li className="mb-3">
                        Each question in the assessment kit will have a
                        specified time limit to answer.
                      </li>
                      <li className="mb-3">
                        Submit the assessment before the specified end date.
                      </li>
                      <li className="mb-3">
                        Click the "Submit" button to finalize the submission.
                      </li>
                    </ul>
                  </div>
                  <div className="action d-flex align-items-center border-top pt-3 justify-content-between">
                    <div className="btn-wrapper d-flex">
                      {userDetails && userDetails?.role ? (
                        <>
                          {userDetails?.role === "hiring_manager" ? null : (
                            <button
                              className="btn btn-primary mb-2 mr-3"
                              disabled={
                                formSubmitError?.msg ||
                                (jobDetails && jobDetails?.already_applied) ||
                                jobDetails?.invite_status === "rejected" ||
                                jobDetails?.status === "inactive"
                              }
                              onClick={() => onJobApplyClick()}
                            >
                              {jobApplyLoading ? (
                                <div className="d-flex justify-content-center align-items-center w-100">
                                  <Spinner animation="border" variant="white" />
                                </div>
                              ) : (
                                <>
                                  {formSubmitError?.msg ||
                                  (jobDetails && jobDetails?.already_applied)
                                    ? "Accepted"
                                    : "Accept"}
                                </>
                              )}
                            </button>
                          )}
                          {formSubmitError?.msg && (
                            <div className="d-flex align-items-center justify-content-end mt-2">
                              <span className="text-danger font-weight-medium">
                                {formSubmitError?.msg}
                              </span>
                            </div>
                          )}
                        </>
                      ) : interviewKit?.is_accepted === true ? (
                        <div className="actions d-flex align-items-center">
                          <button
                            className="btn btn-primary mr-4"
                            onClick={() => onStartClick()}
                          >
                            Let’s start
                          </button>
                          <button
                            className="btn btn-outline-light border"
                            onClick={() => onPracticeClick()}
                          >
                            Let’s practice
                          </button>
                        </div>
                      ) : (
                        <btn
                          className="btn btn-primary mb-2"
                          onClick={() => onJobApplyClick()}
                        >
                          Accept
                        </btn>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
}
export default ViewJobInvite;
